import React from 'react';

const EscapeTheMaze = () => {
  return (
    <div style={{ width: '100%', overflowX: 'hidden', marginBottom: '50px', color: '#F3E5AB', fontFamily: 'Milonga, serif' }}>
      
      {/* Title */}
      <h1 style={{ fontSize: '48px', textAlign: 'center', marginBottom: '20px' }}>Escape the Maze</h1>

      {/* Iframe Section */}
      <div style={{ width: '100%', height: '60vh'}}>
        <iframe
          src="/games/EscapeTheMaze/EscapeTheMaze.html"
          title="Escape The Maze"
          width="100%"
          height="100%"
          style={{  border: 'none', display: 'block'  }}
        />
      </div>

      {/* Text Content */}
      <div style={{ textAlign: 'center', padding: '0px 20px 0' }}>
        <h2 style={{ fontSize: '36px', marginBottom: '20px' }}>How to Play</h2>
        <p style={{ fontSize: '18px', maxWidth: '800px', margin: '0 auto' }}>
          Your goal is to escape the maze without dying to the monsters inside it. Use WASD to move and space to shoot. Each enemy has a different amount of health, so be careful! If an enemy touches you, you will die. In order to escape find the secret portal hidden in each of the 3 levels. Good Luck!
        </p>

        <h2 style={{ fontSize: '36px', margin: '40px 0 20px' }}>About the Game</h2>
        <p style={{ fontSize: '18px', maxWidth: '800px', margin: '0 auto' }}>
          Escape The Maze was developed as a project for my Computer Graphics course, where the objective was to design a fully custom-built game engine using WebGL. The project requirements included implementing three unique enemies, each with distinct movement behaviors; creating a texture system for walls, floors, and enemies; building a complete lighting engine; and designing a multi-level environment.
        </p>
      </div>
    </div>
  );
};

export default EscapeTheMaze;